import React from 'react';
import styled from 'styled-components';
import OverlappingReactions from './OverlappingReactions';

const Container = styled.div`
  position: absolute;
  bottom: -10px; /* Half of emoji height (20px) to make them peek out */
  left: 12px; /* Small offset from left edge */
  display: flex;
  align-items: center;
  z-index: 10; /* Ensure reactions appear above other elements */
`;

const ReactionsContainer = ({
  messageId,
  reactions = {},
  userReactions = {},
  currentUserId,
  onReactionCountClick
}) => {
  
  // Don't render container if no reactions
  const hasReactions = Object.values(reactions).some(count => count > 0);
  if (!hasReactions) {
    return null;
  }
  
  return (
    <Container>
      <OverlappingReactions 
        reactions={reactions}
        userReactions={userReactions}
      />
    </Container>
  );
};

export default ReactionsContainer;